/**
 * Development-only logging. When `getPayload` is passed, it runs only when NODE_ENV is development.
 * @param message — Full log label or description (e.g. a tag, sentence, or `[area] action` string).
 * @param getPayload — Optional; when omitted, only `message` is logged.
 */
export function devLog(message: string, getPayload?: () => unknown): void {
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console -- intentional dev-only logger
        if (getPayload) {
            console.log(message, getPayload());
        } else {
            console.log(message);
        }
    }
}
